import TextToggle from './TextToggle';

export default TextToggle;
